<button
  title="Settings"
  mat-button
  [matMenuTriggerFor]="userProfileMenu"
  class="user-profile-dropdown"
>
  <mat-icon
    inline="true"
    class="profile-dropdown-icon"
    svgIcon="{{ variation === 'side-nav' ? 'settings' : '' }}"
    >{{ variation === 'side-nav' ? '' : 'expand_more' }}</mat-icon
  >
</button>

<mat-menu #userProfileMenu="matMenu" xPosition="before">
  <ng-content></ng-content>
  <button
    title="Invite User"
    (click)="onClickInviteUser()"
    *ngIf="showInviteUser"
    mat-menu-item
  >
    Invite User
  </button>
  <button
    (click)="onClickItAdminTools()"
    *ngIf="showItAdminTools"
    mat-menu-item
  >
    IT Admin Tools
  </button>
  <div *ngIf="!universalLogin">
    <button title="Logout" (click)="onClickLogout()" mat-menu-item>
      Logout
    </button>
  </div>
</mat-menu>
